module.exports = __webpack_public_path__ + "h5/img/pinktitle.756c5b9c.png";